// src/pages/Onboard/StepEmailVerification.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import api from "../../utils/api";


function Progress({ step, total }) {
  const pct = Math.round((step / total) * 100);
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ height: 6, background: "#EDF2F7", borderRadius: 999 }}>
        <div
          style={{
            width: `${pct}%`,
            height: 6,
            background: "#10B981",
            borderRadius: 999,
            transition: "width .3s ease"
          }}
        />
      </div>
      <small className="muted">Step {step} of {total}</small>
    </div>
  );
}

export default function StepEmailVerification({
  totalSteps = 5,
  onVerified,          // ({ email_token, email }) => void
  postcode,            // optional for waitlist
  covered,             // optional for waitlist
}) {
  // send
  const [email, setEmail] = useState(sessionStorage.getItem("onb_email") || "");
  const [sending, setSending] = useState(false);
  const [sendMsg, setSendMsg] = useState("");
  const [already, setAlready] = useState(false);

  // verify
  const [code, setCode] = useState("");
  const [verificationId, setVid] = useState(sessionStorage.getItem("onb_vid") || "");
  const [verifying, setVerifying] = useState(false);
  const [verifyMsg, setVerifyMsg] = useState("");

  const isEmail = (e) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e);

  const send = async () => {
    setSendMsg("");
    setAlready(false);
    const trimmed = email.trim().toLowerCase();
    if (!isEmail(trimmed)) {
      setSendMsg("Enter a valid email address.");
      return;
    }
    setSending(true);
    try {
      const r = await api.post(`/public/email/send-code`, { email: trimmed });
      if (r.data.already_registered) {
        setAlready(true);
        setSendMsg("This email is already registered. You can log in or reset your password.");
        return;
      }
      sessionStorage.setItem("onb_email", trimmed);
      sessionStorage.setItem("onb_vid", r.data.verification_id);
      setVid(r.data.verification_id);
      setSendMsg("We sent a code to your email.");
    } catch (e) {
      setSendMsg(e?.response?.data?.error || "Couldn’t send code.");
    } finally {
      setSending(false);
    }
  };

  const verify = async () => {
    setVerifyMsg("");
    const cleaned = code.replace(/\D/g, "").slice(0, 6);
    if (!verificationId || cleaned.length !== 6) {
      setVerifyMsg("Enter the 6-digit code.");
      return;
    }
    setVerifying(true);
    try {
      const r = await api.post(`/public/email/verify`, {
        verification_id: verificationId,
        code: cleaned
      });

      // quietly join waitlist if not covered
      if (covered === false && postcode) {
        try { await api.post(`/public/waitlist`, { email: r.data.email, postcode }); } catch {}
      }

      // celebrate (confetti is optional)
      try {
        const mod = await import("canvas-confetti");
        mod.default({ particleCount: 120, spread: 70, origin: { y: 0.6 } });
      } catch {}

      onVerified && onVerified({ email_token: r.data.email_token, email: r.data.email });
    } catch (e) {
      const err = e?.response?.data?.error;
      if (err === "invalid_code") setVerifyMsg("That code didn’t match. Try again or resend.");
      else if (err === "expired") setVerifyMsg("Code expired. Please resend a new one.");
      else if (err === "too_many_attempts") setVerifyMsg("Too many attempts. Please resend a new code.");
      else if (err === "not_found") setVerifyMsg("Verification session not found. Please resend the code.");
      else setVerifyMsg(err || "Couldn’t verify code.");
    } finally {
      setVerifying(false);
    }
  };

  return (

  <div className="onboard-wrapper">
    <div className="onboard-card">



    <section className="card" style={{ maxWidth: 560, margin: "2rem auto" }}>
      <Progress step={4} total={totalSteps} />
      <h3>Verify your email</h3>
      <p className="muted">We’ll send a 6‑digit code to confirm it’s really you.</p>

      {/* Send */}
      <div className="row">
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          onKeyDown={e => { if (e.key === "Enter" && !sending && email) send(); }}
          placeholder="you@example.com"
          autoComplete="email"
          inputMode="email"
        />
        <button className="btn" onClick={send} disabled={sending || !email}>
          {sending ? "Sending..." : "Send code"}
        </button>
      </div>
      {sendMsg && (
        <div className={`toast ${already ? "" : "error"}`} style={{ marginTop: 8 }}>
          {sendMsg}
        </div>
      )}
      {already && (
        <div className="actions" style={{ marginTop: 8 }}>
          <Link to="/login" className="btn secondary" style={{ marginRight: 8 }}>Log in</Link>
          <Link to="/forgot-password" className="btn secondary">Reset password</Link>
        </div>
      )}

      {/* Verify */}
      <div className="row" style={{ marginTop: 16 }}>
        <input
          value={code}
          onChange={e => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
          onKeyDown={e => { if (e.key === "Enter") verify(); }}
          placeholder="6-digit code"
          inputMode="numeric"
        />
        <button className="btn" onClick={verify} disabled={verifying || !verificationId || code.length < 6}>
          {verifying ? "Verifying..." : "Verify"}
        </button>
      </div>
      {verifyMsg && <div className="toast error" style={{ marginTop: 8 }}>{verifyMsg}</div>}
    </section>

 </div>
  </div>


  );

}

